import { createContext, useContext, useState } from 'react';
import { TAppContext, TAppContextConfig } from '../../types';
import { getGatekeeper } from '../../gatekeeper';

export const getCompleteContext = (
    contextConfig?: TAppContextConfig
): TAppContext => {
    const gatekeeper = getGatekeeper(contextConfig);
    return {
        gatekeeper,
        deviceInfo: {
            isMobile: contextConfig?.isMobile ?? false,
        },
    };
};

const AppContext = createContext<TAppContext>(getCompleteContext());

export const useAppContext = () => {
    const appContext = useContext(AppContext);
    if (!appContext) {
        throw new Error(
            'useAppContext must be used within a AppContextProvider'
        );
    }
    return appContext;
};

type TGatekeeperProviderProps = {
    children: React.ReactNode;
    context?: TAppContextConfig;
};

export const AppContextProvider = ({
    children,
    context,
}: TGatekeeperProviderProps) => {
    const [value] = useState<TAppContext>(getCompleteContext(context));
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
